import { FeatureFlag } from "@utils/FeatureFlag";
import React from "react";
import { LandingPage as NewLandingPage } from "./new";
import { LandingPage as OriginalLandingPage } from "./original";

/**
 * @Routing
 *
 * @title "Kapcsolat"
 * @description "A bankmonitor.hu elérhetőségei"
 * @route "/kapcsolat/"
 */
const LandingPage: React.FC = () => (
	<>
		<FeatureFlag flag="bankmonitor-hu-webapp.partner-offices">
			<NewLandingPage />
		</FeatureFlag>
		<FeatureFlag flag="bankmonitor-hu-webapp.partner-offices" disabled>
			<OriginalLandingPage />
		</FeatureFlag>
	</>
);

export default LandingPage;
